import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loader from "../../assets/Images/loader.gif";
import imageCompression from "browser-image-compression";

const optionCustContactable = [
  { value: "", label: "Select Option" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];
// const optionCustContactable = ["select option", "Yes", "No"];
const optionChannel = [
  { value: "Cold Calling", label: "Cold Calling" },
  { value: "Digital", label: "Digital" },
  { value: "Event", label: "Event" },
];
const optionIndustrySeg = [
  { value: "Others", label: "Others" },
  { value: "PG", label: "PG" },
];

const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const optionPgCategory = [
  { value: "", label: "Select Option" },
  { value: "Boys PG", label: "Boys PG" },
  { value: "Girls PG", label: "Girls PG" },
  { value: "Service Apartment", label: "Service Apartment" },
  { value: "Co-Living", label: "Co-Living" },
];
const optionPgWifiBill = [
  { value: "", label: "Select Option" },
  { value: "Less than 10000", label: "Less than 10000" },
  { value: "10000 to 15000", label: "10000 to 15000" },
  { value: "15000 to 20000", label: "15000 to 20000" },
  { value: "20000 to 25000", label: "20000 to 25000" },
  { value: "More than 25000", label: "More than 25000" },
];
const optionPgCamera = [
  { value: "", label: "Select Option" },
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

const optionPgSolution = [
  { value: "", label: "Select Option" },
  { value: "Hot Lead", label: "Hot Lead" },
  { value: "Warm Lead", label: "Warm Lead" },
  { value: "Cold Lead", label: "Cold Lead" },
  { value: "Not Interested", label: "Not Interested" },
];

const NewContactForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
      backgroundColor: "transparent",
    }),
  };
  // const customStyles = {
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isDisabled ? 'black' : 'inherit', // Set text color to black when disabled
  //   }),
  // };

  const [isLoading, setIsLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");
  const [selectCustContactable, setSelectCustContactable] = useState(
    optionCustContactable[0]
  );
  const [selectChannel, setSelectChannel] = useState(optionChannel[0]);
  // const [selectIndustrySeg, setSelectIndustrySeg] = useState(
  //   optionIndustrySeg[0]
  // );
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [selectState, setSelectState] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [buildingList, setBuildingList] = useState([]);
  const [selectBuilding, setSelectBuilding] = useState("");
  const [selectPgCategory, setSelectPgCategory] = useState(optionPgCategory[0]);
  const [selectPgWifiBill, setSelectPgWifiBill] = useState(optionPgWifiBill[0]);
  const [selectPgCamera, setSelectPgCamera] = useState(optionPgCamera[0]);
  const [selectPgSolution, setSelectPgSolution] = useState(optionPgSolution[0]);
  const [position, setPosition] = useState({ latitude: null, longitude: null });
  const [fileName, setFileName] = useState("");
  const [base64Content, setBase64Content] = useState("");
  const [fieldsEditable, setFieldsEditable] = useState(true);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpContactStatus, setOtpContactStatus] = useState("");
  const [selectIndustrySeg, setSelectIndustrySeg] = useState("");
  const [industryTypes, setIndustryTypes] = useState([]);

  const [customerData, setCustomerData] = useState({
    companyName: "",
    fullName: "",
    personFirstName: "",
    personLastName: "",
    mobileOne: "",
    mobileTwo: "",
    email: "",
    designation: "",
    campaignName: "",
    eventName: "",
    otp: "",
    specificArea: "",
    specificBuilding: "",
    status: "",
    contactId: "",
    contactStatus: "",
    remark: "",
    pgName: "",
    pgOwner: "",
    pgContactNum: "",
    howManyPg: "",
    pgAddress: "",
    pgAreaName: "",
    NumOfPgFloor: "",
    NumOfPgRoom: "",
    NumOfPgBed: "",
    currentWifiOperator: "",
    NumOfPgBroadband: "",
    dateOfRecharge: "",
    serviceExpect: "",
    changeReason: "",
    sdrRemark: "",
  });

  const handleChange = (e) => {
    // console.log(e.target.name);
    // console.log(e.target.value);
    setCustomerData({ ...customerData, [e.target.name]: e.target.value });
  };

  const handleCustContactable = (selectedOption) => {
    // console.log("e",selectedOption.value);
    setSelectCustContactable(selectedOption);
  };
  const handleChannel = (selectedOptionChannel) => {
    setSelectChannel(selectedOptionChannel);
  };
  // const handleIndustrySeg = (selectedOptionIndustry) => {
  //   setSelectIndustrySeg(selectedOptionIndustry);
  // };

  const handleSelectIndustryType = (selectIndustryType) => {
    setSelectIndustrySeg(selectIndustryType);
  }; 

  const handleSelectPgCategory = (selectPgCategory) => {
    setSelectPgCategory(selectPgCategory);
  };
  const handleSelectWifiBill = (selectWifiBill) => {
    setSelectPgWifiBill(selectWifiBill);
  };
  const handleSelectPgCamera = (selectPgCamera) => {
    setSelectPgCamera(selectPgCamera);
  };
  const handleSelectPgSolution = (selectPgSolution) => {
    setSelectPgSolution(selectPgSolution);
  };

  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    setSelectCity(selectedOption);
    setSelectArea("");
    setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem("password"),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem("userName"),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :",areaData.Response.Data)
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
    setSelectCity("");
    setSelectArea("");
    setSelectBuilding("");
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem("password"),
          stateCode: selectState.value,
          userName: sessionStorage.getItem("userName"),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          // console.log("city",cityData.Response.Data)
          setCityType(cityData.Response.Data);
        } else {
          console.error(
            "City data structure not recognized:",
            cityData.Response
          );
          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    // Fetch cities only if a state is selected
    if (selectState) {
      fetchCities();
    }
  }, [selectState]);

  const handleSelectArea = async (selectedOption) => {
    setSelectArea(selectedOption);
    setSelectBuilding("");
    const areaCode = selectedOption.value;
    const areaName = selectedOption.label.split(" ")[0];
    try {
      const buildingApiUrl = process.env.REACT_APP_API_URL;
      const buildingRequestBody = {
        Action: "getBuilding",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        areaCode: areaCode,
        areaName: areaName,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const buildingResponse = await fetch(buildingApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(buildingRequestBody),
      });
      const buildingData = await buildingResponse.json();
      if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
        setBuildingList(buildingData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Industry API call
        const industryTypeApiUrl = process.env.REACT_APP_API_URL;
        const industryTypeRequestBody = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const industryTypeResponse = await fetch(industryTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(industryTypeRequestBody),
        });
        const industryTypeData = await industryTypeResponse.json();
        // setIndustryTypes(industryTypeData.Response);
        // console.log("industryTypeData :",industryTypeData.Response)
        if (industryTypeData.Response) {
          
          const transformedOptions = industryTypeData.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setIndustryTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setIndustryTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleSendOtp = async (email, mobileNo) => {
    // console.log("Button clicked");
    if (!customerData.mobileOne) {
      toast.warning("Please Enter Customer Contact Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (customerData.mobileOne.length < 10) {
      toast.warning("Please Enter Customer Contact Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(customerData.email)
    ) {
      toast.warning("Please Enter Customer Email Id", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      try {
        setIsLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const otpRequestBody = {
          Action: "sendOTPContact",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          mobileNo: mobileNo,
          preOTP: "",
          userEmail: email,
        };
        const otpResponse = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(otpRequestBody),
        });
        const sendOtpData = await otpResponse.json();
        // console.log("send otp :",sendOtpData)
        if (sendOtpData.Status === "Success") {
          // console.log("send otp :",sendOtpData.Status)
          toast.success("Happy Code Sent", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          // Make fields uneditable for 30 seconds
          setFieldsEditable(false);
          setTimeout(() => {
            setFieldsEditable(true);
          }, 30000); // 30 seconds

          setOtpSent(true);
          setOtp(sendOtpData.Response);
          setIsLoading(false);
          // console.log("sendOtpData.Response :", sendOtpData.Response);
        } else {
          // console.error('Failed to send OTP:', otpResponse.statusText);
          toast.warning(otpResponse.statusText, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error sending OTP:", error);
      }
    }
  };

  const handleVerifyOtp = () => {
    const otpValue = String(otp).trim();
    const customerOtpValue = customerData.otp.trim();
    // console.log("customerData.otp :",customerData.otp);
    // console.log("otp :",otp);
    setIsLoading(true);
    if (otpValue === customerOtpValue) {
      toast.success("Happy Code verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setOtpContactStatus("111260000");
      setIsLoading(false);
    } else {
      toast.warning("Incorrect Happy Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      setOtpContactStatus("111260001");
      setIsLoading(false);
    }
  };

  const handleResendOtp = async (email, mobileNo) => {
    const otpValue = String(otp).trim();
    if (!customerData.mobileOne) {
      toast.warning("Please Enter Customer Contact Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (customerData.mobileOne.length < 10) {
      toast.warning("Please Enter Customer Contact Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }  else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(customerData.email)
    ) {
      toast.warning("Please Enter Customer Email Id", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
    try {
      setIsLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const otpRequestBody = {
        Action: "sendOTPContact",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        mobileNo: mobileNo,
        preOTP: otpValue,
        userEmail: email,
      };
      const otpResponse = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequestBody),
      });
      const resendOtpData = await otpResponse.json();
      // console.log("resend otp :", resendOtpData);
      if (resendOtpData.Status === "Success") {
        // console.log("send otp :",resendOtpData.Status)
        toast.success("Happy Code Sent ", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
        setFieldsEditable(false);
          setTimeout(() => {
            setFieldsEditable(true);
          }, 30000); // 30 seconds
        // setOtpSent(true);
        // setOtp(resendOtpData.Response);
        // console.log("sendOtpData.Response :",sendOtpData.Response)
      } else {
        toast.warning(otpResponse.statusText || "Failed to send OTP", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }}
  };

  // const getLocation = () => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(function (position) {
  //       setPosition({
  //         latitude: position.coords.latitude,
  //         longitude: position.coords.longitude,
  //         message: "Location Captured",
  //       });
  //     });
  //   } else {
  //     // console.log("Geolocation is not available in your browser.");
  //     toast.warning("location is not available in your browser.", {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 1500,
  //     });
  //   }
  // };

 const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }
 
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check browser permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported by this browser.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

  const openCamera = () => {
    document.getElementById("cameraFileInput").click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    // Set compression options
    // const options = {
    //   maxSizeMB: 1, // Maximum file size in MB
    //   maxWidthOrHeight: 1920, // Max width or height
    //   useWebWorker: true, // Use web worker for faster compression
    // };

    const options = {
      maxSizeMB: 0.5, // Reduce maximum file size to 0.5MB for higher compression
      maxWidthOrHeight: 1024, // Reduce max width or height for smaller dimensions
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(";base64,")[1];
        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setFileName(inputText); // Set the input text
        setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  };

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) {
  //     toast.warning("Please Capture Live Picture", {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 1500,
  //     });
  //     return;
  //   }
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const base64String = e.target.result.split(";base64,")[1];
  //     console.log('File content:', base64String); // Log base64 content
  //     const inputText = "Picture Captured";
  //     setFileName(inputText); // Set the input text
  //     setBase64Content(base64String); // Set the base64 content
  //   };
  //   reader.readAsDataURL(file);
  // };

  const popup = () => {
    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        openCamera();
      } else {
        navigate("/newcontactform");
      }
    });
  };

  // Get the current date and time
  const currentDate = new Date();
  // Extract individual components
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1; // Note: Months are zero-based (0-January, 1-February, etc.)
  const date = currentDate.getDate();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  // Format the date and time as a string
  const formattedDateTime = `${year}-${month < 10 ? "0" + month : month}-${
    date < 10 ? "0" + date : date
  } ${hours < 10 ? "0" + hours : hours}:${
    minutes < 10 ? "0" + minutes : minutes
  }:${seconds < 10 ? "0" + seconds : seconds}`;
  // console.log("Current Date and Time:", formattedDateTime);

  const clickSubmit = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to Submit the record ? Once Submitted , Contact will not be editable.</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">SUBMIT</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        handleSubmit();
      } else {
        navigate("/newcontactform");
      }
    });
  };

  const handleSubmit = async () => {
    if (!selectCustContactable.value) {
      toast.warning("Please Select Customer Contactable", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!customerData.companyName) {
      toast.warning("Please Enter Company Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!customerData.personFirstName) {
      toast.warning("Please Enter First name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!customerData.personLastName) {
      toast.warning("Please Enter Last name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      selectCustContactable.value === "Yes" &&
      !customerData.mobileOne
    ) {
      if (!customerData.mobileOne) {
        toast.warning("Please Enter Mobile Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } else if (
      selectCustContactable.value === "Yes" &&
      customerData.mobileOne.length < 10
    ) {
      if (customerData.mobileOne.length < 10) {
        toast.warning("Please Enter Mobile Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } else if (selectCustContactable.value === "Yes" && !customerData.email) {
      if (!customerData.email) {
        toast.warning("Please Enter Email", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } else if (selectCustContactable.value === "Yes" && !customerData.designation) {
      if (!customerData.designation) {
        toast.warning("Please Enter Designation", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
     else if (
      selectCustContactable.value === "Yes" &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(customerData.email)
    ) {
      if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(customerData.email)
      ) {
        toast.warning("Please Enter Email", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } else if (!selectIndustrySeg) {
      toast.warning("Please select Industry Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!fileName) {
      toast.warning("Please select Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!position.message) {
      toast.warning("Please select Live location", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectState) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity) {
      toast.warning("Please  Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea) {
      toast.warning("Please  Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      selectArea.label == "Other (10226)" &&
      !customerData.specificArea
    ) {
      toast.warning("Please Enter Specific Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectBuilding) {
      toast.warning("Please  Select Building", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      selectBuilding.label == "Other (13334)" &&
      !customerData.specificBuilding
    ) {
      toast.warning("Please Enter Specific Building", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if (!customerData.remark) {
    //   toast.warning("Please Enter Remarks", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }
    else {
      if (selectIndustrySeg.label == "PG") {
        if (!customerData.pgName) {
          toast.warning("Please Enter PG Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.pgOwner) {
          toast.warning("Please Enter PG Owner Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.pgContactNum) {
          toast.warning("Please Enter PG Contact Number", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (customerData.pgContactNum.length < 10) {
          toast.warning("Please Enter PG Contact Number", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.howManyPg) {
          toast.warning("Please Enter How Many PG's Does this Owner have", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.pgAddress) {
          toast.warning("Please Enter PG Address with landmark", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.pgAreaName) {
          toast.warning("Please Enter Area Name", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.NumOfPgFloor) {
          toast.warning("Please Enter Number of Floors in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.NumOfPgRoom) {
          toast.warning("Please Enter Number of Rooms in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.NumOfPgBed) {
          toast.warning("Please Enter Number of Beds in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.currentWifiOperator) {
          toast.warning("Please Enter Current Wifi Operator in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.NumOfPgBroadband) {
          toast.warning("Please Enter Number of Broadband connections used", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.dateOfRecharge) {
          toast.warning(
            "Please Enter Date of Recharge of existing connections",
            {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            }
          );
        } else if (!customerData.serviceExpect) {
          toast.warning("Please Enter Service Expectations from the Operator", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!customerData.changeReason) {
          toast.warning("Please Enter Reason to Change the Current operator", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!selectPgWifiBill.value) {
          toast.warning("Please Select Average Monthly Spent on wifi bill", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!selectPgCategory.value) {
          toast.warning("Please Select Category of PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!selectPgCamera.value) {
          toast.warning("Please Select CCTV Camera Available in the PG", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else if (!selectPgSolution.value) {
          toast.warning("Please Select Interested in Spectra PG Solution", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } else {
          const newContactCreateUrl = process.env.REACT_APP_API_URL;
          const contactCreationData = {
            Action: "createContactNew",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            ContactVerificationStatus: otpContactStatus ? otpContactStatus : "",
            area: selectArea.value ? selectArea.value : "",
            building: selectBuilding.value ? selectBuilding.value : "",
            campaignName: customerData.campaignName
              ? customerData.campaignName
              : "",
            channel: selectChannel ? selectChannel.label : "",
            city: selectCity ? selectCity : "",
            companyname: customerData.companyName
              ? customerData.companyName
              : "",
            customercontactable: selectCustContactable
              ? selectCustContactable.label
              : "",
            emailAddress: customerData.email ? customerData.email : "",
            eventname: customerData.eventName ? customerData.eventName : "",
            fileContent: base64Content,
            firstName: customerData.personFirstName
              ? customerData.personFirstName
              : "",
            lastName: customerData.personLastName
              ? customerData.personLastName
              : "",
            lat: position.latitude ? `${position.latitude}` : "",
            long: position.longitude ? `${position.longitude}` : "",
            mobileNumber: customerData.mobileOne ? customerData.mobileOne : "",
            mobileNumber2: customerData.mobileTwo ? customerData.mobileTwo : "",
            password: sessionStorage.getItem("password"),
            remark:
              `Remarks: ${customerData.remark} ; \n` +
              `PG Info: Created By: ${sessionStorage.getItem(
                "userName"
              )} on ${formattedDateTime} \n` +
              `Name of the PG: ${customerData.pgName} \n` +
              `PG Owner Name: ${customerData.pgOwner} \n` +
              `PG Contact Number: ${customerData.pgContactNum} \n` +
              `How Many PG's Does this Owner have: ${customerData.howManyPg} \n` +
              `PG Address with landmark: ${customerData.pgAddress} \n` +
              `Area Name: ${customerData.pgAreaName} \n` +
              `Number of Floors in the PG: ${customerData.NumOfPgFloor} \n` +
              `Number of Rooms in the PG: ${customerData.NumOfPgRoom} \n` +
              `Number of Beds in PG: ${customerData.NumOfPgBed} \n` +
              `Current Wifi Operator in the PG: ${customerData.currentWifiOperator} \n` +
              `Number of Broadband connections used: ${customerData.NumOfPgBroadband} \n` +
              `Average Monthly spent on wifi bill: ${selectPgWifiBill.value} \n` +
              `Date of Recharge of existing connections: ${customerData.dateOfRecharge} \n` +
              `Category of PG: ${selectPgCategory.value} \n` +
              `CCTV Camera Available in the PG: ${selectPgCamera.value} \n` +
              `Service Expectations from the Operator: ${customerData.serviceExpect} \n` +
              `Reason to change the current operator: ${customerData.changeReason} \n` +
              `Interested in Spectra PG solution: ${selectPgSolution.value}`,
            society: "",
            specifyArea: customerData.specificArea
              ? customerData.specificArea
              : "",
            specifybuilding: customerData.specificBuilding
              ? customerData.specificBuilding
              : "",
            Designation: customerData.designation
              ? customerData.designation
              : "",
            state: selectState.value ? selectState.value : "",
            userName: sessionStorage.getItem("userName"),
          };
          try {
            setIsLoading(true);
            const response = await fetch(newContactCreateUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(contactCreationData),
            });
            // console.log(
            //   "Request Payload:",
            //   JSON.stringify(contactCreationData)
            // );
            const data = await response.json();
            // console.log("API Response contact create:", data);
            // console.log("status:", data.response.StatusCode);
            if (data.Status === "Success") {
              toast.success("create Contact Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              navigate("/newContact");
            } else {
              toast.warning(data.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }
          } catch (error) {
            console.error("Error creating lead:", error);
            toast.error("An error occurred. Please try again later.", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } finally {
            setIsLoading(false);
          }
        }
      } else {
        const newContactCreateUrl = process.env.REACT_APP_API_URL;
        const contactCreationData = {
          Action: "createContactNew",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          ContactVerificationStatus: otpContactStatus ? otpContactStatus : "",
          area: selectArea.value ? selectArea.value : "",
          building: selectBuilding.value ? selectBuilding.value : "",
          campaignName: customerData.campaignName
            ? customerData.campaignName
            : "",
          channel: selectChannel ? selectChannel.label : "",
          city: selectCity ? selectCity.value : "",
          companyname: customerData.companyName ? customerData.companyName : "",
          customercontactable: selectCustContactable
            ? selectCustContactable.label
            : "",
          emailAddress: customerData.email ? customerData.email : "",
          eventname: customerData.eventName ? customerData.eventName : "",
          fileContent: base64Content,
          firstName: customerData.personFirstName
            ? customerData.personFirstName
            : "",
          lastName: customerData.personLastName
            ? customerData.personLastName
            : "",
          lat: position.latitude ? `${position.latitude}` : "",
          long: position.longitude ? `${position.longitude}` : "",
          mobileNumber: customerData.mobileOne ? customerData.mobileOne : "",
          mobileNumber2: customerData.mobileTwo ? customerData.mobileTwo : "",
          password: sessionStorage.getItem("password"),
          remark: customerData.remark ? customerData.remark : "",
          society: "",
          specifyArea: customerData.specificArea
            ? customerData.specificArea
            : "",
          specifybuilding: customerData.specificBuilding
            ? customerData.specificBuilding
            : "",
          Designation: customerData.designation ? customerData.designation : "",
          state: selectState.value ? selectState.value : "",
          userName: sessionStorage.getItem("userName"),
        };
        try {
          setIsLoading(true);
          const response = await fetch(newContactCreateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(contactCreationData),
          });
          // console.log("Request Payload:", JSON.stringify(contactCreationData));
          const data = await response.json();
          // console.log("API Response contact create:", data);
          // console.log("status:", data.response.StatusCode);
          if (data.Status === "Success") {
            toast.success("create Contact Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/newContact");
          } else {
            toast.warning(data.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error creating lead:", error);
          toast.error("An error occurred. Please try again later.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        } finally {
          setIsLoading(false);
        }
      }
    }
  };

  const navigate = useNavigate();
  const redirectContactManagement = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/newContact");
      } else {
        // navigate("/newcontactform");
        if (ContactId) {
          navigate(`/newcontactform?ContactId=${ContactId}`);
        } else {
          navigate("/newcontactform");
        }
      }
    });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const ContactId = searchParams.get("ContactId");
  // console.log("ContactId :",ContactId)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getContactNew",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          contactID: ContactId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        // console.log("getContactNew", data);
        // console.log("CompanyName",data.response.Data[0].CompanyName)
        setCustomerData({
          companyName: data.response.Data[0].CompanyName,
          fullName: data.response.Data[0].FullName,
          personFirstName: data.response.Data[0].FirstName,
          personLastName: data.response.Data[0].LastName,
          mobileOne: data.response.Data[0].MobileNumber,
          mobileTwo: data.response.Data[0].MobileNumber2,
          email: data.response.Data[0].EmailAddress,
          designation: data.response.Data[0].Designation,
          campaignName: data.response.Data[0].CampaignName,
          eventName: data.response.Data[0].EventName,
          status: data.response.Data[0].Status,
          contactId: data.response.Data[0].ContactId,
          contactStatus: data.response.Data[0].ContactStatus,
          remark: data.response.Data[0].Remark,
          sdrRemark: data.response.Data[0].RemarkByBackEndTeam,
        });

        setPosition({
          value: data.response.Data[0].CustomerContactable,
          label: data.response.Data[0].CustomerContactable,
        });
        setSelectCustContactable({
          value: data.response.Data[0].CustomerContactable,
          label: data.response.Data[0].CustomerContactable,
        });
        setSelectChannel({
          value: data.response.Data[0].Channel,
          label: data.response.Data[0].Channel,
        });
        setSelectIndustrySeg({
          value: data.response.Data[0].IndustryTypeId,
          label: data.response.Data[0].IndustryTypeId,
        });
        setSelectState({
          value: data.response.Data[0].StateId,
          label: data.response.Data[0].State,
        });
        setSelectCity({
          value: data.response.Data[0].CityId,
          label: data.response.Data[0].City,
        });
        setSelectArea({
          value: data.response.Data[0].AreaId,
          label: data.response.Data[0].Area,
        });
        setSelectBuilding({
          value: data.response.Data[0].BuildingId,
          label: data.response.Data[0].Building,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [ContactId]);

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };


  useEffect(() => {
    if (selectCustContactable.value === 'No') {
      setCustomerData(prevData => ({ ...prevData, mobileOne: '',email:"" }));
    }
  }, [selectCustContactable.value]);

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectContactManagement}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Contact Management</span>
        </div>
      </div>
      {/* ************Header end************ */}

      <div className="container-fluid form-container">
        {isLoading && (
          <div className="loader-wrapper">
            <div className="loader">
              <img src={loader} alt="loading...."></img>
            </div>
          </div>
        )}
        {/* **************Contact Information toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Contact Information</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/**********Contact Information form******** */}
            <form className="contact-form p-2">
              {/* {console.log("selectCustContactable",selectCustContactable.value)} */}
              <div className="select-container mt-2">
                <label className="select-search-label">
                  Customer Contactable*
                </label>
                <Select
                  className=" basic-single disable-fields form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  // styles={{ ...style, ...customStyles }}
                  value={selectCustContactable}
                  isSearchable={false}
                  onChange={handleCustContactable}
                  isDisabled={ContactId ? true : false}
                  options={optionCustContactable.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control  input-text form-control-sm mt-1"
                  id="companyName"
                  name="companyName"
                  value={customerData.companyName}
                  onChange={handleChange}
                  disabled={ContactId ? true : false}
                  style={{ backgroundColor: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Company Name*
                </label>
              </div>

              {ContactId && (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={customerData.fullName}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Full Name
                  </label>
                </div>
              )}

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="personFirstName"
                  name="personFirstName"
                  value={customerData.personFirstName}
                  onChange={handleChange}
                  disabled={ContactId ? true : false}
                  style={{ backgroundColor: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Contact Person First Name*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="personLastName"
                  name="personLastName"
                  value={customerData.personLastName}
                  onChange={handleChange}
                  disabled={ContactId ? true : false}
                  style={{ backgroundColor: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Contact Person Last Name*
                </label>
              </div>

              {/* {console.log("selectCustContactable:", selectCustContactable)} */}
              {selectCustContactable.value === "" ||
              selectCustContactable.value === "Yes" ? (
                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="mobileOne"
                    name="mobileOne"
                    maxLength="10"
                    pattern="[0-9]{10}"
                    value={customerData.mobileOne}
                    onChange={handleChange}
                    disabled={!fieldsEditable || !!ContactId}
                    style={{ background: "transparent" }}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (customerData.mobileOne.length < 10 ||
                          e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Mobile Number*
                  </label>
                </div>
              ) : null}

              {selectCustContactable.value === "" ||
              selectCustContactable.value === "Yes" ? (
                <div className="input-box form-floating ">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="mobileTwo"
                    name="mobileTwo"
                    maxLength="10"
                    pattern="[0-9]{10}"
                    value={customerData.mobileTwo}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (customerData.mobileTwo.length < 10 ||
                          e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Mobile Number 2
                  </label>
                </div>
              ) : null}

              {selectCustContactable.value === "" ||
              selectCustContactable.value === "Yes" ? (
                <div className="input-box form-floating">
                  <input
                    type="email"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="email"
                    name="email"
                    value={customerData.email}
                    onChange={handleChange}
                    disabled={!fieldsEditable || !!ContactId}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Email ID*
                  </label>
                </div>
              ) : null}

              <div className="">
                <label className="select-search-label mt-1">Channel*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Channel"
                  placeholder="Select"
                  styles={style}
                  isSearchable={false}
                  value={selectChannel}
                  onChange={handleChannel}
                  isDisabled={ContactId ? true : false}
                  options={optionChannel.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {selectChannel && selectChannel.value === "Digital" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="campaignName"
                    name="campaignName"
                    value={customerData.campaignName}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Campaign Name*
                  </label>
                </div>
              ) : null}

              {selectChannel && selectChannel.value === "Event" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="eventName"
                    name="eventName"
                    value={customerData.eventName}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Event name*
                  </label>
                </div>
              ) : null}

              {selectCustContactable.value === "" ||
              selectCustContactable.value === "Yes" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="designation"
                    name="designation"
                    value={customerData.designation}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Designation*
                  </label>
                </div>
              ) : null}

              {/* {console.log("selectIndustrySeg",selectIndustrySeg)} */}
              {/* <div className="">
                <label className="select-search-label mt-1">
                  Industry Segment*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select"
                  styles={style}
                  isSearchable={false}
                  value={selectIndustrySeg}
                  onChange={handleIndustrySeg}
                  isDisabled={ContactId ? true : false}
                  options={optionIndustrySeg.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div> */}

                {/* {console.log("selectIndustrySeg",selectIndustrySeg)} */}
              <div className="">
                <label className="select-search-label mt-1">
                  Industry Segment*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select Option"
                  styles={style}
                  isSearchable={true}
                  value={selectIndustrySeg}
                  onChange={handleSelectIndustryType}
                  isDisabled={ContactId ? true : false}
                  options={industryTypes.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              {!ContactId && (
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    id="cameraFileInput"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="picture"
                    name="picture"
                    value={fileName}
                    accept="image/*"
                    capture="environment"
                    style={{ background: "transparent" }}
                    onClick={popup}
                    readOnly
                  />
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={popup}
                  ></i>
                  <label htmlFor="floatingInput" className="paperclip mt-2">
                    Live Picture*
                  </label>
                </div>
              )}

              {!ContactId && (
                <div
                  className="input-box form-floating"
                  style={{ position: "relative" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="locator"
                    name="locator"
                    value={position.message}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                    onFocus={getLocation}
                  />
                  <i
                    className="fa-solid fa-location-dot fa-locator"
                    onClick={getLocation}
                  ></i>
                  <label htmlFor="floatingInput" className="locator mt-2">
                    Live Location*
                  </label>
                </div>
              )}

              {!ContactId &&
                (!selectCustContactable.value ||
                selectCustContactable.value === "Yes" ? (
                  otpContactStatus !== "111260000" ? (
                    <div className="input-box form-floating mb-3">
                      <input
                        type="tel"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="otp"
                        name="otp"
                        maxLength="4"
                        pattern="[0-9]{10}"
                        value={customerData.otp}
                        onChange={handleChange}
                        // onKeyDown={(e) => {
                        //   const allowedKeys = [
                        //     "Backspace",
                        //     "Delete",
                        //     "ArrowLeft",
                        //     "ArrowRight",
                        //     "Tab",
                        //   ];
                        //   const isDigit = /\d/.test(e.key);
                        //   if (
                        //     (isDigit || allowedKeys.includes(e.key)) &&
                        //     (customerData.otp.length < 6 ||
                        //       e.key === "Backspace")
                        //   ) {
                        //     return true;
                        //   } else {
                        //     e.preventDefault();
                        //   }
                        // }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Happy Code*
                      </label>
                    </div>
                  ) : null
                ) : null)}

              {ContactId && (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="status"
                    name="status"
                    value={customerData.status}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Status
                  </label>
                </div>
              )}

              {ContactId && (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="contactStatus"
                    name="contactStatus"
                    value={customerData.contactStatus}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Contact Status
                  </label>
                </div>
              )}

              {ContactId && (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="contactId"
                    name="contactId"
                    value={customerData.contactId}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Contact Id
                  </label>
                </div>
              )}
            </form>
          </div>
        )}

        {selectIndustrySeg && selectIndustrySeg.label == "PG" ? (
          <div
            className="Installation-toggle mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">PG Info</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        ) : null}

        {activeForm === "form2" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form2"
          >
            {/**********PG Info form******** */}
            <form className="contact-form pg-info-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgName"
                  name="pgName"
                  value={customerData.pgName}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Name of the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgOwner"
                  name="pgOwner"
                  value={customerData.pgOwner}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Owner Name*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgContactNum"
                  name="pgContactNum"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.pgContactNum}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (customerData.pgContactNum.length < 10 ||
                        e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Contact Number*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="howManyPg"
                  name="howManyPg"
                  // maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.howManyPg}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (isDigit || allowedKeys.includes(e.key)) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  How Many PG's Does this Owner have*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgAddress"
                  name="pgAddress"
                  value={customerData.pgAddress}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  PG Address with landmark*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="pgAreaName"
                  name="pgAreaName"
                  value={customerData.pgAreaName}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Area Name (eg. Marathalli / Ecity / BTM .. etc..)
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgFloor"
                  name="NumOfPgFloor"
                  // maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.NumOfPgFloor}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (isDigit || allowedKeys.includes(e.key)) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Floors in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgRoom"
                  name="NumOfPgRoom"
                  // maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.NumOfPgRoom}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (isDigit || allowedKeys.includes(e.key)) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Rooms in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgBed"
                  name="NumOfPgBed"
                  // maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.NumOfPgBed}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (isDigit || allowedKeys.includes(e.key)) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Beds in the PG*
                </label>
              </div>
              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="currentWifiOperator"
                  name="currentWifiOperator"
                  value={customerData.currentWifiOperator}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Current Wifi Operator in the PG*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="NumOfPgBroadband"
                  name="NumOfPgBroadband"
                  // maxLength="10"
                  pattern="[0-9]{10}"
                  value={customerData.NumOfPgBroadband}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    if (isDigit || allowedKeys.includes(e.key)) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Number of Broadband connections used*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Average Monthly Spent on wifi bill*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgWifiBill}
                  isSearchable={false}
                  onChange={handleSelectWifiBill}
                  options={optionPgWifiBill.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="input-box form-floating">
                <input
                  type="date"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="dateOfRecharge"
                  name="dateOfRecharge"
                  value={customerData.dateOfRecharge}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Date of Recharge of existing connections*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Category of PG*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgCategory}
                  isSearchable={false}
                  onChange={handleSelectPgCategory}
                  options={optionPgCategory.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  CCTV Camera Available in the PG *
                </label>
                <Select
                  className=" basic-single form-control form-control-sm  p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgCamera}
                  isSearchable={false}
                  onChange={handleSelectPgCamera}
                  options={optionPgCamera.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="serviceExpect"
                  name="serviceExpect"
                  value={customerData.serviceExpect}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Service Expectations from the Operator*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="changeReason"
                  name="changeReason"
                  value={customerData.changeReason}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Reason to Change the Current operator*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Interested in Spectra PG Solution*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="CustContactable"
                  placeholder="Select"
                  styles={style}
                  value={selectPgSolution}
                  isSearchable={false}
                  onChange={handleSelectPgSolution}
                  options={optionPgSolution.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3"
          onClick={() => handleIconClick("form3")}
        >
          <span className="toggle-text">Customer Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form3" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/**********Customer Address form******** */}
            <form className="contact-form p-2">
              <div className="">
                <label className="select-search-label mt-1">State*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select State"
                  styles={style}
                  isSearchable
                  value={selectState}
                  onChange={handleSelectState}
                  isDisabled={ContactId ? true : false}
                  options={optionState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              {/* {console.log("selectCity :",selectCity)} */}
              <div className="">
                <label className="select-search-label mt-1">City*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  name="City"
                  placeholder="Select City"
                  styles={style}
                  isSearchable
                  // value={cityType.find((city) => city.CityCode === selectCity.value)}
                  value={selectCity}
                  onChange={handleSelectCity}
                  isDisabled={ContactId ? true : false}
                  options={cityType.map((data) => ({
                    value: data.CityCode,
                    label: data.CityName,
                  }))}
                />
              </div>

              {/* {console.log("selectArea", selectArea)} */}
              <div className="search-area" style={{ position: "relative" }}>
                <label className="select-search-label mt-1">Area*</label>
                <Select
                  options={areaList.map((area) => ({
                    value: area.AreaCode,
                    label: `${area.AreaName} (${area.AreaCode})`,
                  }))}
                  className="basic-single form-control form-control-sm p-1 custom-select"
                  placeholder="Search Area"
                  styles={style}
                  isSearchable
                  value={selectArea}
                  onChange={handleSelectArea}
                  isDisabled={ContactId ? true : false}
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "63%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>

              {selectArea && selectArea.label == "Other (10226)" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1 "
                    id="specificArea"
                    name="specificArea"
                    value={customerData.specificArea}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Specific Area Name*
                  </label>
                </div>
              ) : null}

              {/* {console.log("selectBuilding :",selectBuilding)} */}
              <div className="search-building" style={{ position: "relative" }}>
                <label className="select-search-label mt-1">Building*</label>
                <Select
                  options={buildingList.map((building) => ({
                    value: building.BuildingCode,
                    label: `${building.BuildingName} (${building.BuildingCode})`,
                  }))}
                  className="basic-single form-control form-control-sm p-1 custom-select"
                  placeholder="Search Building"
                  styles={style}
                  isSearchable
                  value={selectBuilding}
                  // value={selectBuilding && selectBuilding.value !== null && selectBuilding.label !== null ? selectBuilding : null}
                  isDisabled={ContactId ? true : false}
                  onChange={(selectedOption) =>
                    setSelectBuilding(selectedOption)
                  }
                />
                <i
                  className="fas fa-search text-secondary"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "63%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
              </div>

              {selectBuilding && selectBuilding.label == "Other (13334)" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="specificBuilding"
                    name="specificBuilding"
                    value={customerData.specificBuilding}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Specific Building Name*
                  </label>
                </div>
              ) : null}
            </form>
          </div>
        )}

        <div
          className="Installation-toggle mt-3 mb-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Remarks</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/**********Customer Address form******** */}
            <form className="contact-form p-2">
              <div className="remark-area">
                <label htmlFor="floatingInput">Remarks</label>
                <textarea
                  type="text"
                  placeholder=""
                  className=" form-control textarea_remark input-text "
                  id="remark"
                  name="remark"
                  value={customerData.remark}
                  onChange={handleChange}
                  disabled={ContactId ? true : false}
                  style={{ backgroundColor: "transparent" }}
                  // style={{height:"70px"}}
                />
              </div>

              {ContactId && (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-"
                    id="sdrRemark"
                    name="sdrRemark"
                    value={customerData.sdrRemark}
                    onChange={handleChange}
                    disabled={ContactId ? true : false}
                    style={{ backgroundColor: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-3">
                    SDR team remarks :
                  </label>
                </div>
              )}
            </form>
          </div>
        )}

        {!ContactId &&
          (!selectCustContactable.value ||
            selectCustContactable.value === "Yes") &&
          otpContactStatus !== "111260000" &&
          (otpSent ? (
            <div className="row">
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn text-light bg-dark mx-auto rounded-pill btn-verify_otp"
                    onClick={() =>
                      handleResendOtp(
                        customerData.email,
                        customerData.mobileOne
                      )
                    }
                  >
                    Resend Code
                  </button>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center mt-5">
                  <button
                    type="submit"
                    className="btn text-light bg-dark mx-auto rounded-pill btn-resend_otp"
                    onClick={handleVerifyOtp}
                  >
                    Submit Code
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center mt-5 mb-3">
              <button
                type="submit"
                className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                onClick={() =>
                  handleSendOtp(customerData.email, customerData.mobileOne)
                }
              >
                Send Code
              </button>
            </div>
          ))}

        {!ContactId && (
          <div className="text-center mt-5 mb-5">
            <button
              type="submit"
              className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
              onClick={clickSubmit}
            >
              Submit Contact
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default NewContactForm;
